import { DefaultInput, Model, SimpleCommission, SimpleProductsTier } from "@PayPlans/helpers/DefaultSections/Commons";

const autoAlertsDefault = () => ({
	new: DefaultInput(0, "Dollar"),
	preOwned: DefaultInput(0, "Dollar"),
});

const defaultCommission = () => {
	return {
		content: {
			new: [SimpleProductsTier()],
			preOwned: [SimpleProductsTier()],
		},
		newAndPreOwnedRequired: false,
		globalUnitCounts: false,
		applyTiersRetroactively: true,
		isGuaranteedDraw: false,
	};
};

const demoAllowance = () => {
	const max = 9999999;
	return {
		commissions: [SimpleCommission(0, max, { identifier: "allowance", commission: 0 })],
		adjustments: [],
		subjectToReputation: false,
	};
};

const miniDealBrand = (make = "") => {
	const max = 9999999;
	const model = Model(make);
	return {
		...model,
		tiers: [
			{
				from: DefaultInput(-max, "Dollar"),
				to: DefaultInput(0, "Dollar"),
				commission: DefaultInput(0, "Dollar"),
				addCommission: DefaultInput(0, "Percent"),
			},
			{
				from: DefaultInput(0.01, "Dollar"),
				to: DefaultInput(max, "Dollar"),
				commission: DefaultInput(0, "Dollar"),
				addCommission: DefaultInput(0, "Percent"),
			},
		],
		applyGrossRetroactively: false,
		capEnabled: false,
		cap: 0,
	};
};

const miniDeals = (franchises = []) => {
	const makes = franchises?.map((make) => miniDealBrand(make));
	return {
		new: {
			default: makes,
			addons: [],
		},
		preOwned: {
			default: miniDealBrand("Default"),
			addons: [],
		},
	};
};

const modelBased = () => ({
	content: { new: [], preOwned: [] },
	globalUnitCounts: false,
	applyTiersRetroactively: false,
});

const pack = (title = "", amount = 0, soft = false) => ({
	title,
	soft,
	amount: DefaultInput(amount, "Dollar"),
});

const packsDefault = () => ({ new: [], preOwned: [] });

export {
	autoAlertsDefault as AutoAlertsDefault,
	defaultCommission as DefaultCommission,
	demoAllowance as DemoAllowance,
	miniDeals as MiniDeals,
	miniDealBrand as MiniDealBrand,
	modelBased as ModelBased,
	pack as Pack,
	packsDefault as PacksDefault,
};
